import { defineComponent as _defineComponent } from 'vue'
interface Props {}


export default /*#__PURE__*/_defineComponent({
  __name: 'next-section-arrow',
  setup(__props: any, { expose }) {
  expose();



const scrollToNextSection = (e: PointerEvent) => {
    const currentSection = (e.target as HTMLButtonElement).closest("section");

    if (currentSection) {
        const nextSection = currentSection.nextSibling;

        if (nextSection) {
            (nextSection as HTMLElement).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
    }
};

const __returned__ = { scrollToNextSection }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})